import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

/**
 * Buscar dados
 *
 * @param {*} cod_ibge
 * @param {*} nu_ine
 * @param {*} publico_alvo
 * @returns {Array}
 */
export async function getDados(cod_ibge, nu_ine, publico_alvo) {
  try {
    const { data } = await api.get(
      `/app/v2/campanha-gripe/${cod_ibge}/equipe/${nu_ine}/publico-alvo/${publico_alvo}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Filtra os registros classificados como vermelhos.
 * @param {Array} cadastros Lista de registros
 * @returns {Array} Registros com dados desatualizados
 */
export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.dias_ult_dose == null) return true

    if (item.dias_ult_dose > 365) {
      return true
    } else {
      return false
    }
  })
  return filtro
}

/**
 * Filtra os registros classificados como verdes.
 * @param {Array} cadastros Lista de registros
 * @returns {Array} Registros com dados atualizados
 */
export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.dias_ult_dose != null && item.dias_ult_dose <= 365) {
      return true
    } else {
      return false
    }
  })
  return filtro
}

/**
 * Gera o relatório em PDF
 *
 * @param {*} cadastros
 * @param {*} selectEquipe
 * @param {*} selectProfissional
 * @param {*} selectMicroArea
 * @param {*} publicoAlvo
 */
export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  selectMicroArea,
  publicoAlvo
) {
  const titlePdf = 'Campanha gripe'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf =
    'Público alvo a ser vacinado na campanha contra a gripe no ano atual'
  const headersPdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'INFLUENZA TRIVALENTE',
    'DOCUMENTO',
  ]

  const dataPdf = cadastros.map((item) => {
    const documentos = []
    if (item.nu_cpf) documentos.push(`CPF ${item.nu_cpf}`)
    if (item.nu_cns) documentos.push(`CNS ${item.nu_cns}`)

    return {
      no_cidadao: item.no_cidadao,
      dt_nascimento: utils.methods.formatDate(item.dt_nascimento),
      no_mae: item.no_mae,
      micro_area: item.micro_area,
      dt_aplicacao: utils.methods.formatDate(item.dt_aplicacao),
      documento: documentos.join('\n'),
      dias_ult_dose: item.dias_ult_dose,
    }
  })

  const table = utils.methods.createTablePdf(dataPdf)
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const equipeInfo = [
        { label: 'Equipe', value: selectEquipe.no_equipe },
        { label: 'CNES', value: selectEquipe.nu_cnes },
        { label: 'INE', value: selectEquipe.ine_esf_eap },
        {
          label: 'Profissional ACS',
          value:
            selectProfissional != null
              ? selectProfissional.no_profissional
              : '',
        },
        {
          label: 'Microárea',
          value: selectMicroArea,
        },
        { label: 'Público alvo', value: publicoAlvo.label },
      ]

      verticalPosition = utils.methods.bodyPdf(
        doc,
        equipeInfo,
        verticalPosition
      )

      const anoAtual = new Date().getFullYear()

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ row, section }) => {
          if (section === 'head') {
            doc.setTextColor(0, 0, 0)
            return
          }

          const dataAplicacao = row.raw[6]
          const cor =
            dataAplicacao != null && dataAplicacao <= 365
              ? [2, 99, 57] // verde
              : [194, 10, 16] // vermelho

          doc.setTextColor(...cor)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
